enum EmailDomainDrawerTypeEnum {
  DomainDrawer = 0,
  EmailDrawer = 1,
}
export default EmailDomainDrawerTypeEnum;
